// Where I've worked and what I did
export const experiences = [
  {
    id: 1,
    title: 'Frontend Developer Intern',
    company: 'OZ Developers pvt Ltd.',
    duration: 'January 2026 - Present ',
    type: 'Internship',
    description:
      'Worked on developing responsive web applications using React and modern frontend technologies. Collaborated with senior developers to implement new features and improve user experience.',
    achievements: [
      'Developed responsive web applications using React',
      'Improved application performance by 25% through code optimization',
      'Collaborated with design team to implement pixel-perfect UI components',
    ],
    technologies: ['React', 'JavaScript', 'CSS3', 'HTML5', 'Git', 'Tailwind CSS'],
  },
  {
    id: 2,
    title: 'Freelance Web Developer',
    company: 'Self-Employed',
    duration: 'Jul 2025 - Present',
    type: 'Freelance',
    description:
      'Providing web development services to small businesses and startups. Creating custom websites, web applications, and providing technical consulting.',
    achievements: [
      'Implemented responsive designs for mobile and desktop',
      'Provided ongoing maintenance and support for client websites',
    ],
    technologies: ['React', 'JavaScript', 'HTML5', 'CSS3', 'Tailwind CSS', 'Git'],
  },
];

// My education background
export const education = [
  {
    degree: 'Bachelor of Science in Computer Science',
    institution: 'Superior University Lahore, Gold Campus',
    year: '2023 - 2027',
    description:
      'Focused on software engineering, algorithms, data structures, and web development. Completed coursework in programming languages, database systems, and software engineering principles.',
  },
];

// Certificates I've earned
export const certifications = [
  {
    name: 'NAVTTC Certified Course in Web Development',
    issuer: 'National Vocational & Technical Training Commission (NAVTTC), Pakistan',
    year: '2025',
    credential: 'IT Specialist – HTML5 Application Development (Certiport)',
  },
  {
    name: 'CSS, JavaScript, PHP and Python Programming – All in One',
    issuer: 'Udemy',
    year: '2025',
    credential: 'CSS, JavaScript, PHP and Python Programming All in One Certificate',
  },

  {
    name: 'Zero to Hero JavaScript Course',
    issuer: 'The Cyber Champs',
    year: '2024',
    credential: 'The Cyber Champs Javascript Course Completion Certificate',
  },
];
